"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GalleryBodySkeleton = exports.GallerySubjectSkeleton = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var GallerySubjectSkeleton = function GallerySubjectSkeleton(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('skeleton bg-secondary w-full h-6 mb-4', className)
  });
};

exports.GallerySubjectSkeleton = GallerySubjectSkeleton;

var GalleryBodySkeleton = function GalleryBodySkeleton(_ref2) {
  var className = _ref2.className;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('skeleton bg-secondary w-full h-full', className)
  });
};

exports.GalleryBodySkeleton = GalleryBodySkeleton;
//# sourceMappingURL=GalleryBody.js.map